export default __webpack_public_path__ + "static/transform-2ff8dbf71567b5bbf40b58f18b49288d.png";